import View from 'ln/view/View';
import { IAsset } from './MediaSearchView';

class MediaSearchAssetView extends View{

    public constructor( public data: IAsset ) {
        super( data );

        this.defaultTemplate = 'krw.mediasearch-sequence-asset';
    }
}

export default MediaSearchAssetView;